import { render } from "./WelcomeMessage.vue?vue&type=template&id=32750a70&scoped=true&ts=true&lang=pug"
import script from "./WelcomeMessage.vue?vue&type=script&lang=ts"
export * from "./WelcomeMessage.vue?vue&type=script&lang=ts"

import "./WelcomeMessage.vue?vue&type=style&index=0&id=32750a70&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32750a70"]])

export default __exports__